var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.titleValue,
        visible: _vm.newCodeDialog,
        "custom-class": "drawerClass",
        direction: "ltr",
        size: "520px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.newCodeDialog = $event
        },
        close: _vm.handleNewCodeDialog,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            padding: "0 20px",
            "overflow-y": "auto",
            height: "calc(100vh - 120px)",
            "margin-bottom": "40px",
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "search-form",
              attrs: {
                inline: false,
                model: _vm.addForm,
                rules: _vm.rules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("routes.flowName"),
                            prop: "flowDirectName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("userManage.pleaseInput"),
                              clearable: "",
                              maxlength: "100",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.addForm.flowDirectName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "flowDirectName", $$v)
                              },
                              expression: "addForm.flowDirectName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("routes.selectTrunkLine"),
                            prop: "type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              on: { change: _vm.handleType },
                              model: {
                                value: _vm.addForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "type", $$v)
                                },
                                expression: "addForm.type",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("basicData.trunkLine"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("basicData.branchLine"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("routes.latestArrivalTime"),
                            prop: "latestArriveTime",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              format: "HH:mm",
                              "value-format": "HH:mm",
                            },
                            model: {
                              value: _vm.addForm.latestArriveTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "latestArriveTime", $$v)
                              },
                              expression: "addForm.latestArriveTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("routes.departureTransferCenter"),
                            prop: "departTransferCenterId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.addForm.departTransferCenterId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addForm,
                                    "departTransferCenterId",
                                    $$v
                                  )
                                },
                                expression: "addForm.departTransferCenterId",
                              },
                            },
                            _vm._l(_vm.transferCenterList, function (item) {
                              return _c("el-option", {
                                key: item.siteId,
                                attrs: {
                                  label: item.siteName,
                                  value: item.siteId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("routes.发车时间"),
                            prop: "departureTime",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              format: "HH:mm",
                              "value-format": "HH:mm",
                            },
                            model: {
                              value: _vm.addForm.departureTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "departureTime", $$v)
                              },
                              expression: "addForm.departureTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.addForm.nextSiteList, function (stop, index) {
                return _c(
                  "el-card",
                  { key: index, attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _vm.addForm.nextSiteList.length > 1
                          ? _c("el-button", {
                              attrs: {
                                type: "text",
                                size: "mini",
                                icon: "el-icon-close",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeStop(index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("routes.下一站流向"),
                                  prop: "nextSiteList." + index + ".nextSiteId",
                                  rules: _vm.rules.nextSiteId,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value: stop.nextSiteId,
                                      callback: function ($$v) {
                                        _vm.$set(stop, "nextSiteId", $$v)
                                      },
                                      expression: "stop.nextSiteId",
                                    },
                                  },
                                  _vm._l(_vm.siteList, function (item) {
                                    return _c("el-option", {
                                      key: item.siteId,
                                      attrs: {
                                        label: item.siteName,
                                        value: item.siteId,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: _vm.$t("routes.estimatedArrivalTime"),
                                  prop:
                                    "nextSiteList." +
                                    index +
                                    ".expectedArriveTime",
                                  rules: _vm.rules.expectedArriveTime,
                                },
                              },
                              [
                                _c("el-time-picker", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    format: "HH:mm",
                                    "value-format": "HH:mm",
                                  },
                                  model: {
                                    value: stop.expectedArriveTime,
                                    callback: function ($$v) {
                                      _vm.$set(stop, "expectedArriveTime", $$v)
                                    },
                                    expression: "stop.expectedArriveTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: _vm.$t("routes.crossDay"),
                                  prop: "nextSiteList." + index + ".acrossDay",
                                  rules: _vm.rules.acrossDay,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value: stop.acrossDay,
                                      callback: function ($$v) {
                                        _vm.$set(stop, "acrossDay", $$v)
                                      },
                                      expression: "stop.acrossDay",
                                    },
                                  },
                                  _vm._l(_vm.isAcrossDay, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "demo-drawer__footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addNextStop },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.addNextStop")) + " ")]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.handleNewCodeDialog } },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }